var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 300,
    viewBox: "0 0 15 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Benin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#E8112D",
    width: 15,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FCD116",
    width: 15,
    height: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#008751",
    width: 6,
    height: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenin);
export default __webpack_public_path__ + "static/media/benin.5fa70e7f1f48dea35c76617942faba57.svg";
export { ForwardRef as ReactComponent };